import React, { FC, ReactElement } from 'react';
import Modal from 'react-modal';
import { useHistory } from 'react-router';
import ReactHtmlParser from 'react-html-parser';
import Icon from '../Icon';

Modal.setAppElement('#root');

interface Props {
  isOpen: boolean;
  close?: () => void;
  text: string;
  redirect?: string;
}

const AlertModal: FC<Props> = ({ isOpen, close, text, redirect }): ReactElement => {
  const history = useHistory();

  const handleClose = () => {
    if (close) close();
    if (redirect) history.push(redirect);
  };

  return (
    <Modal
      className="modal-login-content"
      overlayClassName="modal-login-overlay"
      isOpen={isOpen}
      onRequestClose={handleClose}>
      <h3 className="modal-title">Информация</h3>
      <button className="modal-close" type="button" onClick={handleClose}>
        <Icon name="close" />
      </button>
      <p className="modal-text">{ReactHtmlParser(text)}</p>
    </Modal>
  );
};

export default AlertModal;
